import { render } from "./DocumentModal.vue?vue&type=template&id=395828e8"
import script from "./DocumentModal.vue?vue&type=script&lang=js"
export * from "./DocumentModal.vue?vue&type=script&lang=js"

import "./DocumentModal.vue?vue&type=style&index=0&id=395828e8&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__